import { StaffPage } from '@wonderschool/ccms-ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { getTitlePrefix } from '../config/env';
import { RouteNameEnum, useRoutes } from '../navigation';
import { isStaffEmailTaken } from './isStaffEmailTaken';

const Staff = () => {
  const { gotoRouteByName } = useRoutes();
  const { t } = useTranslation();
  const { ccmsAddStaffExistingAccount } = useFlags();

  const handleStaffRowClick = (staffId: string) => {
    return gotoRouteByName(RouteNameEnum.STAFF_DETAILS, [{ name: 'staffId', value: staffId }]);
  };

  const renderPageHead = () => (
    <Helmet>
      <title>
        {getTitlePrefix()}
        {t('pages.staff.browserTitle')}
      </title>
      <body className="staff" />
    </Helmet>
  );

  const validateEmail = (email: string, organizationId: string) =>
    isStaffEmailTaken(email, organizationId, !!ccmsAddStaffExistingAccount);

  return (
    <>
      {renderPageHead()}
      <StaffPage onNavigateToStaffDetails={handleStaffRowClick} isEmailTaken={validateEmail} />
    </>
  );
};

export default Staff;
